class AnalyticsService {
  constructor() {
    this.events = [];
    this.sessionId = this.generateSessionId();
    this.startTime = Date.now();
    this.isEnabled = true;
  }

  generateSessionId() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
  }

  track(eventName, properties = {}) {
    if (!this.isEnabled) return;

    const event = {
      id: this.generateEventId(),
      sessionId: this.sessionId,
      eventName,
      properties,
      timestamp: Date.now(),
      url: window.location.href,
      userAgent: navigator.userAgent
    };

    this.events.push(event);
    this.saveToStorage();
    
    console.log('Analytics event tracked:', event);
    return event;
  }

  trackPageView(page) {
    return this.track('page_view', {
      page,
      title: document.title,
      referrer: document.referrer
    });
  }

  trackUserInteraction(element, action, data = {}) {
    return this.track('user_interaction', {
      element,
      action,
      ...data
    });
  }

  trackArtworkView(artworkId, artworkTitle) {
    return this.track('artwork_view', {
      artworkId,
      artworkTitle
    });
  }

  trackSearch(query, results) {
    return this.track('search', {
      query,
      resultsCount: results.length
    });
  }

  trackExhibitionView(exhibitionId, exhibitionTitle) {
    return this.track('exhibition_view', {
      exhibitionId,
      exhibitionTitle
    });
  }

  getEvents(filter = {}) {
    let filteredEvents = this.events;

    if (filter.eventName) {
      filteredEvents = filteredEvents.filter(event => 
        event.eventName === filter.eventName
      );
    }

    if (filter.startDate) {
      filteredEvents = filteredEvents.filter(event => 
        event.timestamp >= filter.startDate
      );
    }

    if (filter.endDate) {
      filteredEvents = filteredEvents.filter(event => 
        event.timestamp <= filter.endDate
      );
    }

    return filteredEvents;
  }

  getSessionDuration() {
    return Date.now() - this.startTime;
  }

  getAnalyticsSummary() {
    const totalEvents = this.events.length;
    const pageViews = this.events.filter(e => e.eventName === 'page_view').length;
    const interactions = this.events.filter(e => e.eventName === 'user_interaction').length;
    const sessionDuration = this.getSessionDuration();

    return {
      sessionId: this.sessionId,
      totalEvents,
      pageViews,
      interactions,
      sessionDuration,
      startTime: this.startTime,
      currentTime: Date.now()
    };
  }

  generateEventId() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
  }

  saveToStorage() {
    try {
      localStorage.setItem('gallery_analytics', JSON.stringify({
        events: this.events.slice(-100), // Keep only last 100 events
        sessionId: this.sessionId,
        startTime: this.startTime
      }));
    } catch (error) {
      console.warn('Failed to save analytics to storage:', error);
    }
  }

  loadFromStorage() {
    try {
      const data = localStorage.getItem('gallery_analytics');
      if (data) {
        const parsed = JSON.parse(data);
        this.events = parsed.events || [];
        // Don't restore session data - each session should be unique
      }
    } catch (error) {
      console.warn('Failed to load analytics from storage:', error);
    }
  }

  clearEvents() {
    this.events = [];
    this.saveToStorage();
  }

  enable() {
    this.isEnabled = true;
  }

  disable() {
    this.isEnabled = false;
  }
}

const analyticsService = new AnalyticsService();
export default analyticsService;